import { defineComponent as n, createBlock as l, openBlock as r, unref as a, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconCheckSmall",
  __name: "IconCheckSmall",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (r(), l(a(i), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M17.53 8.073a.75.75 0 0 1 0 1.06l-6.646 6.647a1.25 1.25 0 0 1-1.768 0L6.47 13.134a.75.75 0 0 1 1.06-1.06L10 14.542l6.47-6.47a.75.75 0 0 1 1.06 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
